import {
    CHANGE_PRE_MEMBERSHIP,
    CHANGE_Dl_STATUS,
    DELETE_DL_USER,
    SET_DL_USER,
    SET_CONTRIBUTOR,
    ADD_Dl_USER,
    EDIT_Dl_USER,
    DL_PROGRAM_UNENROLL,
  } from "../constants";
  
  const initialState = [];
  
  export const DlUserReducer = (
    state = initialState,
    { type, payload }
  ) => {
    switch (type) {
      case SET_DL_USER: {
        state = [...payload];
        return state;
      }
      case SET_CONTRIBUTOR: {
        state = [...payload];
        return state;
      }
      case ADD_Dl_USER: {
        let temp = [...state];
        let index = temp.findIndex((user) => user.email === payload.email);
        if (index > -1) {
          temp[index] = payload;
        } else {
          temp = [payload, ...temp];
        }
        return temp;
      }
      case EDIT_Dl_USER: {
        let temp = [...state];
        let index = temp.findIndex((user) => user._id === payload._id);
        if (index > -1) {
          temp[index] = payload;
        }
        return temp;
      }
      case CHANGE_Dl_STATUS: {
        let temp = [...state];
        let index = temp.findIndex((user) => user._id === payload);
        if (index > -1) {
          temp[index].is_active = !temp[index].is_active;
        }
        return temp;
      }
      case CHANGE_PRE_MEMBERSHIP: {
        let temp = [...state];
        let index = temp.findIndex((user) => user._id === payload._id);
        if (index > -1) {
          temp[index] = payload;
        }
        return temp;
      }
      case DL_PROGRAM_UNENROLL: {
        console.log("payload Dl", payload)
        let temp = [...state];
        let index = temp.findIndex((user) => user._id === payload.user_id);
        
        if (index > -1) {
          if(temp[index].enroll_program[0].event_id === payload.program_id){
            temp[index].enroll_program[0].coursedetails.program_name = null
            temp[index].enroll_program[0].coursedetails.programID = null
          }
          console.log("temp",temp[index])
          temp[index].enroll_count = temp[index].enroll_count - 1;
        }
        return temp;
      }
      case DELETE_DL_USER: {
        let temp = [...state];
        let index = temp.findIndex((user) => user._id === payload);
        if (index > -1) {
          temp.splice(index, 1);
        }
        return temp;
      }
      default: {
        return state;
      }
    }
  };
  